module.exports = __webpack_public_path__ + "static/media/slider03.21341982.jpg";